/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import moment from 'moment';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_OBJ_INVOICE,
  screenData: data,
});

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDetailObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPLAY_DETAIL_OBJ_INVOICE,
  detailScrData: data,
});
// dispatch Quarter
export const dispatchQtrRange = (data) => ({
  type: actionTypes.GET_QUARTER_INVOICE,
  payload: data,
});
// dispatch Date Range
export const dispatchDateRange = (data) => ({
  type: actionTypes.SET_DATE_RANGE_INVOICE,
  payload: data,
});
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA_INVOICE,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgPreInvoice = (data) => ({
  type: actionTypes.GET_ERROR_MSG_INVOICE,
  payload: data,
});
// select option dispatch
export const getSelectedOption = (data) => ({
  type: actionTypes.SELECT_OPTION,
  payload: data,
});
// select report option dispatch
export const getSelectedReportOption = (data) => ({
  type: actionTypes.SELECT_REPORT_OPTION,
  payload: data,
});
// preinvoice summary dispatch
export const dispatchPreInvoiceSummary = (data) => ({
  type: actionTypes.GET_PRE_INVOICE_SUMMARY,
  payload: data,
});
// preinvoice detail dispatch
export const dispatchPreInvoiceDetail = (data) => ({
  type: actionTypes.GET_PRE_INVOICE_DETAIL,
  payload: data,
});
// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_INVOICE,
  payload: data,
});
// rebate program name dispatch function
export const dispatchRebateProgramName = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM_NAME_INVOICE,
  payload: data,
});
//  get rebate programe function
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
  // dispatch(dispatchErrorMsgPreInvoice([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgPreInvoice([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
};

// get preinvoice Summary
export const getPreInvoiceSummary = (value) => (dispatch) => {
  dispatch(dispatchPreInvoiceSummary([]));
  return axios
    .post(serviceEndPoint.GET_PREINVOICE_SUMMARY, value)
    .then((response) => {
      if (response?.data?.preInvoiceUnitAdjustmentsVO.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(dispatchPreInvoiceSummary(response?.data));
      }
    })
    .catch((response) => {
      dispatch(dispatchPreInvoiceSummary([]));
    });
};
// get preinvoice Detail
export const getPreInvoiceDetail = (value) => (dispatch) => {
  dispatch(dispatchPreInvoiceDetail([]));
  return axios
    .post(serviceEndPoint.GET_PREINVOICE_DETAIL, value)
    .then((response) => {
      if (response?.data?.preInvoiceUnitAdjustmentDetailsVO.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        const tempObj = { ...response?.data };
        tempObj.preInvoiceUnitAdjustmentDetailsVO =
          response?.data?.preInvoiceUnitAdjustmentDetailsVO?.map((item) => {
            item.ndc = item.labelerCode
              ? `${item.labelerCode}-${item.productCode}-${item.packageSize}`
              : ' ';
            item.adjustedUnit = item.labelerCode
              ? parseFloat(item.adjustedUnit).toFixed(4)
              : '';
            item.adjustedURA = parseFloat(
              parseFloat(item.adjustedUnit || 0) *
                parseFloat(item.adjustedURA || 0) *
                parseFloat(item.adjustmentRecordCount || 0)
            );
            item.adjustmentRecordCount = item.adjustmentRecordCount
              ? parseFloat(item.adjustmentRecordCount).toFixed(2)
              : '0.00';
            return item;
          });
        dispatch(dispatchPreInvoiceDetail(tempObj));
      }
    })
    .catch((response) => {
      dispatch(dispatchPreInvoiceDetail([]));
    });
};

// Refresh Functinality
export const refreshPreInvoiceUnitAdujustment = () => ({
  type: actionTypes.REFRESH_PREINVOICE_UNIT_ADJUSTMENT,
  payload: {},
});
export const refreshPreInvoiceUnitAdujustmentDisplay = () => ({
  type: actionTypes.REFRESH_PREINVOICE_UNIT_ADJUSTMENT_DISPLAY,
  payload: {},
});
// dispatch Display screen Object
export const dispatchDisplayObjInvoice = (data) => ({
  type: actionTypes.SET_DISPLAY_OBJ_INVOICE,
  payload: data,
});
